<template>
<v-container fluid>
  
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="orange"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  
  <v-row>
    <v-col offset-md="1" md="12">
      <h1>Points for collection <i>"{{ collname }}"</i></h1>
    </v-col>
  </v-row>
  
  <v-row>
    <v-col offset-md="1" md="7">
      
      
      <l-map id="pointsmap" :zoom=5 :center="[45.759761, 3.130985]">
	<l-tilelayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"></l-tilelayer>
	<l-marker
	  v-for="point in points"
	  :key="point.name"
	  :lat-lng="[point.lat, point.lon]"
	  @click="setSelectedPoint(point)"
	  :icon="point.icon"
	  >
	</l-marker>
	
	<l-marker
	  v-for="point in customPoints"
	  :key="point.name + 'CUS'"
	  :lat-lng="[point.lat, point.lon]"
	  :icon="greenIcon"
	  >
	</l-marker>
      </l-map>
      
    </v-col>
    
    <v-col md="3">
      
      <v-card>
	<v-card-title>Point {{ selectedPoint.name }}</v-card-title>
	<v-card-text>
	  <v-list dense>
	    <v-list-item>
              <v-list-item-content>Description:</v-list-item-content>
              <v-list-item-content class="align-end">{{ selectedPoint.description }}</v-list-item-content>
	    </v-list-item>
	    <v-list-item>
              <v-list-item-content>Point ID:</v-list-item-content>
              <v-list-item-content class="align-end">{{ selectedPoint.point_id }}</v-list-item-content>
	    </v-list-item>
            <v-list-item>
              <v-list-item-content>Altitude:</v-list-item-content>
              <v-list-item-content class="align-end">{{ selectedPoint.altitude }}m</v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>Latitude:</v-list-item-content>
              <v-list-item-content class="align-end">{{ selectedPoint.lat }}</v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>Longitude:</v-list-item-content>
              <v-list-item-content class="align-end">{{ selectedPoint.lon }}</v-list-item-content>
            </v-list-item>
	  </v-list>
	</v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
  <!-- <v-row v-if="pointData.data !== undefined"> -->
    <!-- <v-row> -->
      <!--   <v-col offset-md="1" md="10"> -->
	
	<!-- 	<v-card> -->
	  <!-- 	  <v-card-title>Data for point <i>"{{ selectedPoint.name }}"</i></v-card-title> -->
	  <!-- 	  <v-card-text> -->
	    
	    <!-- 	    <v-data-table -->
	    <!-- 	      hide-default-footer -->
	    <!-- 	      :items-per-page="99999999999" -->
	    <!-- 	      :headers="headers" -->
	    <!-- 	      :items="pointData.data" -->
	    <!-- 	      ></v-data-table> -->
	    <!-- 	  </v-card-text> -->
	  <!-- 	</v-card> -->
	<!--   </v-col> -->
      <!-- </v-row> -->
    
    
    <!-- <v-row> -->
      <!--   <v-col offset-md="1" md="10"> -->
	
	<!-- 	<v-card> -->
	  <!-- 	  <v-card-title>Graph</v-card-title> -->
	  <!-- 	  <v-card-text> -->
	    
	    <!-- 	    <LineChart :chart-data="graphData" v-if="this.graphData.datasets !== undefined"></LineChart> -->
	    
	    <!-- 	  </v-card-text> -->
	  <!-- 	</v-card> -->
	<!--   </v-col> -->
      <!-- </v-row> -->
    
    
    <v-row>
      <v-col offset-md="1" md="10">
	<h1>Data visualization</h1>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col offset-md="1" md="10">
	
	<v-card>
	  
	  <v-tabs
	    background-color="grey darken-4"
	    color="red"
	    centered
	    dark
	    icons-and-text
	    grow
	    >
	    
	    <v-tab>
	      Dates selection
	      <v-icon>fa-calendar</v-icon>
	    </v-tab>
	    
	    <v-tab>
              Data table
              <v-icon>fa-table</v-icon>
	    </v-tab>
	    
	    <v-tab>
              Charts
              <v-icon>fa-chart-area</v-icon>
	    </v-tab>
	    
	    <v-tab-item>
	      <v-row>
		<v-col md="5">
		  <v-date-picker
		    v-model="fromDate"
		    :max="toDate"
		    full-width
		    landscape
		    color=""
		    ></v-date-picker>
		</v-col>
		
		<v-col md="2">
		  <div id="arrowright">
		    <v-icon x-large>fa-arrow-right</v-icon>
		  </div>
		</v-col>
		
		<v-col md="5">
		  <v-date-picker
		    v-model="toDate"
		    :min="fromDate"
		    :max="today"
		    full-width
		    landscape
		    color=""
		    ></v-date-picker>
		</v-col>
		
	      </v-row>

	      
	    </v-tab-item>
	    
	    <v-tab-item>
	      <v-data-table
	        hide-default-footer
	        :items-per-page="99999999999"
	        :headers="headers"
	        :items="pointData.data"
	        ></v-data-table>
	    </v-tab-item>
	    
	    <v-tab-item>
	      <LineChart :options="graphOptions" :chart-data="graphData" v-if="this.graphData.datasets !== undefined"></LineChart>
	    </v-tab-item>
	    
	  </v-tabs>
	</v-card>
	
      </v-col>
    </v-row>
    
</v-container>
</template>

<script>
import { config } from '../config';

const L = require('leaflet');
import LineChart from './LineChart.js'

export default {
    name: 'PointsViewerCMP',
    
    props: {
	collname: String,
    },
    
    components: {
	LineChart,
    },
    
    data: () => ({
	boolf: false,
        loading: true,
        errorState: false,
	points: [],
	customPoints: [],
	mapCenter: {},
	selectedPoint: {},
	pointData: {},
	icon: L.icon({
	    iconUrl: require('../assets/marker.png'),
	    iconSize: [40, 40],
	    iconAnchor: [20, 20]
	}),
	
	greenIcon: L.icon({
	    iconUrl: require('../assets/markerG.png'),
	    iconSize: [40, 40],
	    iconAnchor: [20, 20]
	}),
	headers: [],
	graphOptions: {
	    bezierCurve: false,
	    responsive: true,
	    maintainAspectRatio: false,
	},
	graphData: {},
	graphHeight: 200,
	colors: [
	    '#EF5350',
	    '#7E57C2',
	    '#42A5F5',
	    '#26A69A',
	    '#66BB6A',
	    '#FFEE58',
	],
	today: new Date().toISOString().substr(0, 10),
	toDate: new Date().toISOString().substr(0, 10),
	fromDate: new Date().toISOString().substr(0, 10),
    }),
    
    watch: {
	fromDate() {
	    this.loadPointData();
	},

	toDate() {
	    this.loadPointData();
	},
    },
    
    mounted() {
	this.loadData();
    },
    
    computed: {
	graphStyle() {
	    return {
		height: `${this.graphHeight}px`,
		position: 'relative',
	    };
	},
    },
    
    methods: {
        loadData() {
            this.loading = true;
            const url = `${config.baseUrl}weasel/collections/${this.collname}/points`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
		let polypoints = res.data.map(p => {
		    return [p.lat, p.lon];
		});
		let polyOpts = {color:'red'};
		let poly = L.polygon(polypoints , polyOpts);
		let center = poly.getBounds().getCenter();
		
		this.mapCenter = [center.lat, center.lng];
		let ppoints = res.data;
		ppoints.forEach(p => {
		    p.icon = this.icon;
		});
		
		
                this.points = ppoints;
		
                this.loading = false;
                this.errorState = false;
            }).catch((err) => {
                console.log(err);
                this.errorState = true;
                this.loading = false;
            });
        },
	
	loadPointData() {
	    this.loading = true;
	    let url = '';
	    if (this.fromDate === this.toDate) {
		url = `${config.baseUrl}weasel/collections/${this.collname}/${this.selectedPoint.point_id}/data`;
	    } else {
		url = `${config.baseUrl}weasel/collections/${this.collname}/${this.selectedPoint.point_id}/data?fromdate=${this.fromDate}&todate=${this.toDate}`;
	    }
	    
	    this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
		this.pointData = res.data;
		this.makeHeaders();
		this.makeGraph();
                this.loading = false;
                this.errorState = false;
            }).catch((err) => {
                console.log(err);
                this.errorState = true;
                this.loading = false;
            });
	},
	
	setSelectedPoint(point) {
	    this.customPoints = [];
	    this.selectedPoint = point;
	    this.customPoints.push(this.selectedPoint);
	    this.loadPointData();
	},
	
	describe(paramName) {
	    if (paramName === 'time') return 'Time';
	    return this.pointData.parameters.filter(p => p.name === paramName)[0].description;
	},
	
	makeHeaders() {
	    let headers = [];
	    this.pointData.parameters.forEach(p => {
		headers.push({
		    text: p.description,
		    value: p.name,		
		});
		this.headers = headers;
	    });
	},
	
	makeGraph() {
	    let colorCounter = 0;
	    let _graphData = {
	    	labels: this.pointData.data.map(d => d.time),
	    	datasets: [],
	    };
	    
	    this.headers.forEach(h => {
		let _paramData = [];
		if (h.value !== 'time') {
		    
		    
		    this.pointData.data.forEach(p => {
	    		_paramData.push(p[h.value]);
		    });
		    
		    _graphData.datasets.push({
	    		label: h.text,
	    		borderColor: this.colors[colorCounter],
			lineTension: 0,
	    		data: _paramData
	    	    });
		    
		    colorCounter++;
		}
	    });
	    
	    // this.selectedPoint;
	    // this.pointData.data.forEach(p => {
	    // 	_graphData.datasets[0].data.push(p[paramName]);
	    // });
	    
	    this.graphData = _graphData;
	},
	
    },
};
</script>

<style lang="scss" scoped>
#pointsmap {
    height: 70vh;
}

#arrowright {
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
}
</style>
